import DataTable from 'react-data-table-component';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

export const DataTableComp = ({ columns, data, ...rest }) => {
    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState(data);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        setFilteredData(data);
    }, [data]);

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearch(value);

        const filtered = data.filter(row => {
            return columns.some(column => {
                let columnValue = '';

                if (typeof column.selector === 'function') {
                    columnValue = column.selector(row);
                } else if (typeof column.selector === 'string') {
                    columnValue = row[column.selector];
                } else if (column.cell && typeof column.cell === 'function') {
                    const cellContent = column.cell(row);
                    if (React.isValidElement(cellContent)) {
                        columnValue = cellContent.props.children ? cellContent.props.children.toString() : '';
                    } else {
                        columnValue = cellContent ? cellContent.toString() : '';
                    }
                }

                // Log each column and its value for debugging
                // console.log(`Row ID: ${row.id}, Column Selector: ${column.selector}, Column Value: ${columnValue}`);

                if (columnValue && typeof columnValue === 'string') {
                    return columnValue.toLowerCase().includes(value);
                }
                return false;
            });
        });

        setFilteredData(filtered);
    };

    const subHeaderComponent = (
        <div className="position-relative w-300px">
            <input
                type="text"
                placeholder="Search"
                value={search}
                onChange={handleSearch}
                className="form-control form-control-sm pl-40px w-100-per"// Padding left for the icon space
            />
            <SearchIcon className="search-icon"  />
        </div>
    );

    const updatedColumns = [
        {
            name: 'S No.',
            selector: (_, index) => index + 1 + (currentPage - 1) * rowsPerPage,
            sortable: false,
            width: '80px',
        },
        ...columns,
    ];

    return (
        <DataTable
            className='custom-data-table'
            pagination
            paginationPerPage={rowsPerPage} // Default rows per page
            paginationRowsPerPageOptions={[10, 20, 50, 100]} // Page size options
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                setRowsPerPage(currentRowsPerPage);
                setCurrentPage(currentPage);
            }}
            columns={updatedColumns}
            sortIcon={<ArrowDropUpIcon />}
            data={filteredData}
            subHeader
            subHeaderComponent={subHeaderComponent}
            {...rest}
        />
    );
}

export default DataTableComp;

DataTableComp.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired
};
